import { BodyText, Flex } from '@utilitywarehouse/hearth-react';

import { UserTypeDisplayMap } from '@features/Remote/constants';
import { AppointmentParticipantType } from '@generated/gql/graphql';

interface LobbyListItemPlaceholderProps {
  userType: AppointmentParticipantType;
  description: string;
}
const LobbyListItemPlaceholder = ({
  userType,
  description,
}: LobbyListItemPlaceholderProps) => {
  return (
    <Flex
      direction="column"
      alignItems="start"
      className="remote__LobbyListItem"
    >
      <BodyText weight="semibold" size="md">
        Waiting for {UserTypeDisplayMap[userType]} to join&hellip;
      </BodyText>
      <BodyText weight="regular" size="sm" color="secondary">
        {description}
      </BodyText>
    </Flex>
  );
};

export { LobbyListItemPlaceholder };
